import { Icon, useActive, useAttrs } from "@remirror/react";
import { useLinkState } from "../../hooks/useLinkState";
import { FloatingToolbar } from "@remirror/react-ui";
import "./FloatingLinkToolbar.css";

type Props = {
  nodeId: string;
};

export function FloatingLinkToolbar({ nodeId }: Props) {
  const { isEditing } = useLinkState(nodeId);
  const active = useActive();
  const activeLink = active.link();
  const url = (useAttrs().link()?.href as string) ?? "";

  const openLinkContainer = (
    <div className="open-link-wrapper">
      <Icon name="link" size={16} />
      Open
      <a className="truncate-text" href={url} target="_blank" rel="noreferrer">
        {url}
      </a>
    </div>
  );

  return (
    <>
      {!isEditing && activeLink && (
        <FloatingToolbar>{openLinkContainer}</FloatingToolbar>
      )}
    </>
  );
}
